module.exports = __webpack_public_path__ + "38a8f8ef214c021ed9c882b38aa50e40.png";